import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-rinse',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './rinse.component.html',
  styleUrl: './rinse.component.scss'
})
export class RinseComponent {}
